import { IconProps } from "@/components/Icons/index";

export const CreditCardPlusIcon: React.FC<IconProps> = (props) => (
  <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M12.7804 9.97226C12.7804 11.4349 11.8697 12.4676 10.4064 12.4676H4.37467C2.91069 12.4676 2 11.4349 2 9.97226V6.02722C2 4.56453 2.91069 3.53125 4.37467 3.53125H9.8174"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.2914 6.70312H2"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.60938 9.89844H6.38729"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.60938 9.89844H6.38729"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.7812 3.92969V7.49199"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.5625 5.15432L12.782 3.92969L14.0014 5.15432"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
